import update from "immutability-helper";
import { ProgressReduxActions } from "./Action";

export const sblProgressState: any = [
  {
    id: "introduction",
    label: "Introduction",
    parentCompleted: false,
    parentCurrent: true,
    subItems: [
      {
        id: "intro-details",
        label: "Your details",
        current: true,
        completed: false,
      },
      {
        id: "intro-loan",
        label: "Your loan",
        current: false,
        completed: false,
      },
      {
        id: "intro-business",
        label: "Your business",
        current: false,
        completed: false,
      },
    ],
  },
  {
    id: "security",
    label: "Security",
    parentCompleted: false,
    parentCurrent: false,
    subItems: [
      {
        id: "sec-property",
        label: "Property details",
        current: false,
        completed: false,
      },
      {
        id: "sec-liabilities",
        label: "Liabilities & legal ties",
        current: false,
        completed: false,
      },
    ],
  },
  {
    id: "verification",
    label: "Verification",
    parentCurrent: false,
    parentCompleted: false,
    subItems: [
      {
        id: "verif-review",
        label: "Review details",
        current: false,
        completed: false,
      },
      {
        id: "verif-directors",
        label: "Directors",
        current: false,
        completed: false,
      },
      {
        id: "verif-identity",
        label: "Identity verification",
        current: false,
        completed: false,
      },
    ],
  },
  {
    id: "finalise",
    label: "Finalise",
    parentCurrent: false,
    parentCompleted: false,
    subItems: [
      {
        id: "final-solicitor",
        label: "Solicitor details",
        current: false,
        completed: false,
      },
      {
        id: "final-bank",
        label: "Bank details",
        current: false,
        completed: false,
      },
      {
        id: "final-agreements",
        label: "Agreements & Signing",
        current: false,
        completed: false,
      },
    ],
  },
];

export const rndProgressState: any = [
  {
    id: "introduction",
    label: "Introduction",
    parentCompleted: false,
    parentCurrent: true,
    subItems: [
      {
        id: "intro-details",
        label: "Your details",
        current: true,
        completed: false,
      },
      {
        id: "intro-loan",
        label: "Loan details",
        current: false,
        completed: false,
      },
    ],
  },
  {
    id: "review-details",
    label: "Review details",
    parentCurrent: false,
    parentCompleted: false,
    subItems: [
      {
        id: "review-approval",
        label: "Conditional approval",
        current: false,
        completed: false,
      },
    ],
  },
  {
    id: "finalise",
    label: "Finalise",
    parentCurrent: false,
    parentCompleted: false,
    subItems: [
      {
        id: "final-business",
        label: "Business details",
        current: false,
        completed: false,
      },
      {
        id: "final-directors",
        label: "Directors",
        current: false,
        completed: false,
      },
      {
        id: "final-identity",
        label: "Identity verification",
        current: false,
        completed: false,
      },
      {
        id: "final-accountant",
        label: "Accountant details",
        current: false,
        completed: false,
      },
      {
        id: "final-bank",
        label: "Bank details",
        current: false,
        completed: false,
      },
      {
        id: "final-agreements",
        label: "Agreements & Signing",
        current: false,
        completed: false,
      },
    ],
  },
];

export const getProgressStateByLoanType = (
  loanType: "sbl" | "rnd" | null
): any => {
  if (loanType === "rnd") return rndProgressState;
  return sblProgressState;
};

const findSectionIndex = (state, parentId) => {
  return state.findIndex((section) => section.id === parentId);
};

const findSubItemIndex = (section, subItemId) => {
  return section.subItems.findIndex((item) => item.id === subItemId);
};

const initialProgressState = {
  currentLoanType: null,
  sblProgress: sblProgressState,
  rndProgress: rndProgressState,
};

const ProgressStateReducer = (
  state: any = initialProgressState,
  action: any = { type: "", payload: {} }
): any => {
  switch (action.type) {
    case ProgressReduxActions.SET_SBL_PROGRESS:
      return {
        ...state,
        sblProgress: action.payload,
      };

    case ProgressReduxActions.SET_RND_PROGRESS:
      return {
        ...state,
        rndProgress: action.payload,
      };

    case ProgressReduxActions.SWITCH_LOAN_TYPE:
      return {
        ...state,
        currentLoanType: action.payload,
      };

    case ProgressReduxActions.RESET_PROGRESS_BY_LOAN_TYPE: {
      const { loanType } = action.payload;
      if (loanType === "rnd") {
        return {
          ...state,
          rndProgress: rndProgressState,
        };
      } else {
        return {
          ...state,
          sblProgress: sblProgressState,
        };
      }
    }

    case ProgressReduxActions.SET_CURRENT_STEP: {
      const { parentId, subItemId, resetOthers } = action.payload;
      const sectionIndex = findSectionIndex(state, parentId);

      if (sectionIndex === -1) return state;

      const subItemIndex = findSubItemIndex(state[sectionIndex], subItemId);
      if (subItemIndex === -1) return state;

      let newState = state;

      if (resetOthers) {
        newState = state.map((section) => ({
          ...section,
          parentCurrent: false,
          subItems: section.subItems.map((item) => ({
            ...item,
            current: false,
          })),
        }));
      }

      return update(newState, {
        [sectionIndex]: {
          parentCurrent: { $set: true },
          subItems: {
            [subItemIndex]: {
              current: { $set: true },
            },
          },
        },
      });
    }

    case ProgressReduxActions.MARK_STEP_COMPLETED: {
      const { parentId, subItemId, completed } = action.payload;
      const sectionIndex = findSectionIndex(state, parentId);

      if (sectionIndex === -1) return state;

      const subItemIndex = findSubItemIndex(state[sectionIndex], subItemId);
      if (subItemIndex === -1) return state;

      return update(state, {
        [sectionIndex]: {
          subItems: {
            [subItemIndex]: {
              completed: { $set: completed },
            },
          },
        },
      });
    }

    default:
      return state;
  }
};

export default ProgressStateReducer;
